import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './router'
Vue.config.productionTip = false
// import Antd from 'ant-design-vue/es';
// import 'ant-design-vue/dist/antd.css';
// Vue.use(Antd);

import { Menu, Breadcrumb, Pagination, ConfigProvider } from 'ant-design-vue/es';
Vue.use(ConfigProvider)
Vue.use(Menu);
Vue.use(Breadcrumb);
Vue.use(Pagination)
import 'ant-design-vue/lib/menu/style/css';
import 'ant-design-vue/lib/breadcrumb/style/css';
import 'ant-design-vue/lib/pagination/style/css';

const IE11RouterFix = {
  methods: {
    hashChangeHandler: function () { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
    isIE11: function () { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function () { if (this.isIE11()) { window.addEventListener('hashchange', this.hashChangeHandler); } },
  destroyed: function () { if (this.isIE11()) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};
new Vue({
  router,
  store,
  render: h => h(App),
  mixins: [IE11RouterFix],
}).$mount('#app')
